(function () {
  document.querySelectorAll('.drv-lfeat').forEach(function (root) {
    const list = root.querySelector('[data-drv-lfeat-list]');
    const rail = root.querySelector('[data-drv-lfeat-rail]');
    const thumb = root.querySelector('[data-drv-lfeat-thumb]');
    const mq = window.matchMedia('(max-width: 989.98px)');
    function update() {
      if (mq.matches || list.scrollHeight <= list.clientHeight + 1) { rail.classList.remove('is-visible'); return; }
      rail.classList.add('is-visible');
      const max = list.scrollHeight - list.clientHeight;
      const range = rail.clientHeight - 4 - thumb.offsetHeight;
      thumb.style.transform = 'translateY(' + (max ? (list.scrollTop / max) * range : 0) + 'px)';
    }
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
